import React from "react";
import { useNavigate } from "react-router-dom";

const RefundCancellationPolicy = () => {
  const navigate = useNavigate();

  const cardStyle = {
    background: "#fff",
    padding: "25px",
    borderRadius: "14px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    marginBottom: "25px",
  };

  return (
    <div
      style={{
        background: "#f4f7fb",
        minHeight: "100vh",
        paddingBottom: "40px",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #0f172a, #2563eb)",
          color: "#fff",
          textAlign: "center",
          padding: "60px 20px",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "42px",
            fontWeight: "700",
          }}
        >
          Refund & Cancellation Policy
        </h1>

        <p
          style={{
            marginTop: "15px",
            fontSize: "18px",
            opacity: 0.9,
          }}
        >
          Transparent • Fair • Customer Friendly
        </p>
      </div>

      <div
        style={{
          maxWidth: "1100px",
          margin: "30px auto",
          padding: "0 20px",
        }}
      >
        {/* Back Button */}

        <button
          onClick={() => navigate(-1)}
          style={{
            background: "#2563eb",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            marginBottom: "20px",
          }}
        >
          ← Back
        </button>

        <div
          style={{
            textAlign: "center",
            marginBottom: "25px",
            color: "#64748b",
          }}
        >
          Last Updated: 17 June 2026
        </div>

        {/* Cancellation */}

        <div style={cardStyle}>
          <h2 style={{ color: "#2563eb", marginTop: 0 }}>
            📦 Order Cancellation
          </h2>

          <p>✅ Orders can be cancelled before dispatch.</p>

          <p>
            ✅ Our representative may contact you before dispatch to confirm
            order and delivery details.
          </p>

          <p>
            ✅ To cancel an order, please contact our support team as early as
            possible.
          </p>

          <p>
            ❌ Orders cannot be cancelled once they have been dispatched for
            delivery.
          </p>
        </div>

        {/* Refund */}

        <div style={cardStyle}>
          <h2 style={{ color: "#2563eb", marginTop: 0 }}>
            💰 Refund Policy
          </h2>

          <p>
            ✅ Full refund will be issued if the order is cancelled before
            dispatch.
          </p>

          <p>
            ✅ If a product becomes unavailable after payment, the paid amount
            will be refunded.
          </p>

          <p>
            ✅ Failed online payments where money is deducted but order is not
            confirmed will be refunded automatically.
          </p>
        </div>

 {/* OPEN BOX DELIVERY  */}

        <div style={cardStyle}>
          <h2 style={{ color: "#2563eb", marginTop: 0 }}>
            📦 Open-Box Delivery & Product Inspection
          </h2>
	<p>
PharmaHelp follows an open-box delivery process to help customers check their orders at the time of delivery.
</p>
          <p>
            ✅ Customers are requested to inspect the delivered products in the presence of the delivery representative before accepting the order.
          </p>

          <p>
            ✅ Please check the product name, quantity, packaging and visible condition before accepting the delivery.
          </p>

          <p>
            ✅ If a product is damaged, incorrect, or visibly defective at the time of delivery, please inform the delivery representative immediately and contact PharmaHelp support.
          </p>

 <p>
            ✅ Such issues reported at the time of delivery will be verified, and a replacement will be arranged where appropriate, subject to verification and product availability. If a replacement is unavailable, the support team will advise on the applicable refund or resolution.
          </p>

 <p>
            ✅ Once an order has been inspected and accepted, routine returns or exchanges are not accepted, except where required by applicable law or where an issue is covered by PharmaHelp's applicable policy.
          </p>
<p>
            ✅ Please retain the original packaging and invoice until the order has been checked.
          </p>


        </div>  

        {/* Non Refundable */}

        <div style={cardStyle}>
          <h2 style={{ color: "#2563eb", marginTop: 0 }}>
            🚫 Non-Refundable Items
          </h2>

          <p>
            ❌ Delivery charges are non-refundable if the order reaches the
            delivery address and is refused without a valid reason.
          </p>

          <p>
            ❌ For safety and hygiene reasons, the following items are generally
            not eligible for return or refund:
          </p>

          <ul>
            <li>Medicines with broken seals</li>
            <li>Opened healthcare products</li>
            <li>Personal care products</li>
            <li>Products damaged due to customer misuse</li>
          </ul>
        </div>

        {/* Processing Time */}

        <div style={cardStyle}>
          <h2 style={{ color: "#2563eb", marginTop: 0 }}>
            ⏳ Refund Processing Time
          </h2>

          <ul>
            <li>UPI Refunds: 3–5 Working Days</li>
            <li>Bank Transfers: 5–7 Working Days</li>
            <li>Card Payments: 5–10 Working Days</li>
          </ul>
        </div>

        {/* Contact */}

        <div
          style={{
            background: "#eff6ff",
            borderRadius: "14px",
            padding: "30px",
            textAlign: "center",
            border: "1px solid #bfdbfe",
          }}
        >
          <h2
            style={{
              color: "#1e40af",
              marginTop: 0,
            }}
          >
            Need Assistance?
          </h2>

          <p>
            Our support team is available to help with refunds, cancellations,
            payments, and order-related queries.
          </p>

          <p>
            <strong>📧 Email:</strong> info@pharmahelp.co.in
          </p>

          <p>
            <strong>📞 Phone:</strong> +91 6395050131
          </p>

          <p>
            <strong>🕘 Support Hours:</strong> 9:00 AM – 9:00 PM (All Days)
          </p>

          <p>
            <strong>🌐 Website:</strong> https://pharmahelp.co.in
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundCancellationPolicy;